
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import ServiceProductsModalForm from "@/UI/components/forms/serviceGeneral/ServiceProductsModalForm.vue";
import {IServicesListItem} from "@/entity/services/services.types";
import { IConsumables } from '@/entity/consumables/consumables.types';
import { StoresStore } from '@/store/modules/Warehouse/Warehouse';
import {ServiceStore} from "@/store/modules/Services";
import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";
import { ConsumableStore } from "@/store/modules/Consumables"
import ServiceGeneralForm from "@/form/serviceGeneral/serviceGeneral";
import ServiceGeneralProductsCreateForm, { ConsumablesTypeForm } from "@/form/serviceGeneral/serviceGeneralProductsCreate";
import {message} from "ant-design-vue";
import {getStudioId} from "@/UI/lib/state";

@Component({
  components: {FormGroup, PageTitle, ServiceProductsModalForm}
})
export default class ServiceProducts extends Vue {
  @Prop() readonly service!: IServicesListItem;

  forms = new ConsumablesTypeForm()
  formService = new ServiceGeneralForm();
  form = new ServiceGeneralProductsCreateForm();
  visible = false

  get serviceProductsColumns(): ITableColumn[]{
    return TablesStore.serviceDetailProductsColumns;
  }
  get consumables(): IConsumables | null {
    return ConsumableStore.consumables;
  }

  showModal() {
    this.forms = new ConsumablesTypeForm()
    this.visible = true;
  }

  handleCancel(e:any) {
    this.visible = false;
  }

  async saveProducts(){
    this.forms.service_id = parseInt(this.$route.params['id'])
    if (await ConsumableStore.create(this.forms)) {
      this.visible = false;
      await ConsumableStore.fetchAll({filter: {service_id: parseInt(this.$route.params.id)}});
    }
  }

  async deleteConsumable(id: number): Promise<void> {
    if ((await ConsumableStore.delete({id: id})).status) {
        message.success(i18nText("Расходник успешно удален"));
        await ConsumableStore.fetchAll({filter: {service_id: parseInt(this.$route.params.id)}});
    } else  {
        message.error(i18nText("Что то пошло не так..."))
    }
  }

  async created(): Promise<void>{
    await ServiceStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    //await StoresStore.fetchAll({filter: {salon_id: getStudioId(this)}})
    await ConsumableStore.fetchAll({filter: {service_id: parseInt(this.$route.params.id)}});
    //await ProductsStockStore.fetchAll({filter: {salon_id: getStudioId(this)}})
  }
}
